// TODO: convert to use Typography component
// This is currently an isolated instance as its used as a block in the campaign page
import * as React from 'react';
import styled from 'styled-components';

type Props = {
  value: string;
  variant?: string;
};

const Text = styled.p({
  width: '100%',
  maxWidth: '816px',
  margin: '0 auto',
  opacity: 0.9,
  fontWeight: 400,
  fontSize: '16px',
  letterSpacing: '.11px',
  lineHeight: '24px',
  textAlign: 'center',

  '@media screen and (min-width: 768px)': {
    fontSize: '20px',
    letterSpacing: '.21px',
    lineHeight: '28px',
  },
});

const CampaignTypography: React.FC<Props> = ({ value, variant = 'p' }) => {
  // @ts-ignore (it doesn't like passing "as" as a variable instead of string)
  return <Text as={variant === 'paragraph' ? 'p' : variant}>{value}</Text>;
};

export default CampaignTypography;
